import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'

export const accountDetailsOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    columnBtn: false,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "业务编号",
            prop: "number",
            search: true,
            type: "input"
        },
        {
            label: "操作类型",
            search: true,
            prop: "source",
            type: "select",
            dicData: DIC.FINANCIAL_SOURCE,
        },
        {
            label: "交易金额",
            prop: "money",
            type: "input"
        },
        {
            label: "交易类型",
            prop: "type",
            type: "select",
            dicData: [{
                label: '收入',
                value: "INCOME"
            }, {
                label: '支出',
                value: "EXPEND"
            }],
        },
        {
            label: "支付类型",
            search: true,
            prop: "payType",
            type: "select",
            dicData: DIC.PAY_TYPE,

        },
        {
            label: "银行卡号",
            prop: "bankNumber",
            type: "input"
        },
        {
            label: "银行名称",
            prop: "bankName",
            type: "input"
        },
        {
            label: "凭证",
            prop: "url",
            type: 'input',
            solt: true,
            formsolt: true,
        },
        {
            label: "资金状态",
            prop: "status",
            search: true,
            type: "select",
            dicData: DIC.CASH_STATUS,

        },
        {
            label: "备注",
            prop: "remarks",
            type: "input",
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            // search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return row.createTime = row.createTime * 1
            }
        },
        {
            label: "创建人",
            prop: "createBy",
            search: true,
            type: "input"
        },
        {
            label: "创建时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                console.log(row)
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};